namespace Nobox.Nobox {
    export interface ExcelColumnRequest {
        Path?: string;
        Search?: string;
    }
}
